var map = {
	"./components/GamePlayer/translations/en.json": 37509,
	"./components/GamePlayer/translations/es.json": 1898,
	"./components/VideoPlayer/Controls/translations/en.json": 21823,
	"./components/VideoPlayer/Controls/translations/es.json": 69380,
	"./components/VideoPlayer/Player/translations/en.json": 71032,
	"./components/VideoPlayer/Player/translations/es.json": 3611,
	"./components/VideoPlayer/SettingsPanel/translations/en.json": 79170,
	"./components/VideoPlayer/SettingsPanel/translations/es.json": 90573,
	"./components/base/ArrowButton/translations/en.json": 12029,
	"./components/base/ArrowButton/translations/es.json": 57618,
	"./components/base/CloseButton/translations/en.json": 57740,
	"./components/base/CloseButton/translations/es.json": 99671,
	"./components/base/MediaBadge/translations/en.json": 26643,
	"./components/base/MediaBadge/translations/es.json": 33792,
	"./components/base/MessageBanner/translations/en.json": 39217,
	"./components/base/MessageBanner/translations/es.json": 67470,
	"./components/global/Head/translations/en.json": 78732,
	"./components/global/Head/translations/es.json": 60983,
	"./components/global/LocalStationLogo/translations/en.json": 98872,
	"./components/global/LocalStationLogo/translations/es.json": 99035,
	"./components/global/SiteFooter/translations/en.json": 76154,
	"./components/global/SiteFooter/translations/es.json": 97941,
	"./components/global/SiteHeader/translations/en.json": 67900,
	"./components/global/SiteHeader/translations/es.json": 2855,
	"./components/global/StationConfirmation/translations/en.json": 7655,
	"./components/global/StationConfirmation/translations/es.json": 44828,
	"./components/modules/BridgeModal/translations/en.json": 99902,
	"./components/modules/BridgeModal/translations/es.json": 33569,
	"./components/modules/MediaList/translations/en.json": 10368,
	"./components/modules/MediaList/translations/es.json": 64467,
	"./components/modules/PropertiesNavigationBanner/translations/en.json": 60973,
	"./components/modules/PropertiesNavigationBanner/translations/es.json": 50978,
	"./components/modules/SponsorsGrid/translations/en.json": 40735,
	"./components/modules/SponsorsGrid/translations/es.json": 88292,
	"./components/modules/StationSettings/translations/en.json": 18361,
	"./components/modules/StationSettings/translations/es.json": 77318,
	"./components/private/LocaleSelector/translations/en.json": 24153,
	"./components/private/LocaleSelector/translations/es.json": 99462,
	"./pages/tests/language-localization/translations/en.json": 67010,
	"./pages/tests/language-localization/translations/es.json": 72781,
	"./pages/tests/series-header/sponsors.json": 68110,
	"./pages/tests/video-player/translations/en.json": 57829,
	"./pages/tests/video-player/translations/es.json": 1066,
	"./pages/videos/translations/en.json": 41532,
	"./pages/videos/translations/es.json": 91175,
	"./test-data/games-data.json": 12722,
	"./test-data/language-localization/missing-en/translations/es.json": 91767,
	"./test-data/language-localization/missing-es/translations/en.json": 75611,
	"./test-data/language-localization/performance-test/translations/en.json": 72497,
	"./test-data/language-localization/performance-test/translations/es.json": 750,
	"./test-data/language-localization/proper/translations/en.json": 98138,
	"./test-data/language-localization/proper/translations/es.json": 51157,
	"./test-data/lower-modules.json": 61859,
	"./utils/language-localization/config-all-locales.json": 69769,
	"./utils/language-localization/config-next-js-i18n-dev.json": 6538,
	"./utils/language-localization/config-next-js-i18n-prod.json": 60800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53840;